// extracted by mini-css-extract-plugin
module.exports = {"arrow":"comparisonArrow_arrow__3dzL7","green":"comparisonArrow_green__1eQLY","red":"comparisonArrow_red__2UhbK","rectangle":"comparisonArrow_rectangle__1Ur3F"};